import * as React from 'react';
import { Divider, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useRequestState } from '@app/hooks';
import { LoadingGate, Scrollbar } from '@app/components';
import { GeneralInformationForm } from './general-information-form';
import { getMyProfile } from './slice';
import { selectMyProfileFormState } from './selectors';
import { BankInformationPage } from './bank-Information-form';
import { EduInformationPage } from './education-information-form';
import { DocumentInformationPage } from './document-information-form';

const MyProfilePage = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getMyProfile());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectMyProfileFormState,
    errorShown: true,
  });

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <LoadingGate loading={loading}>
      <>
        <Scrollbar sx={{ position: 'relative', maxHeight: '100%' }}>
          <Stack pb={3}>
            {!isSmallScreen && <Header title={Strings.page_title.my_profile} />}
            <Divider sx={{ width: '100%' }} />
            <Stack p={2} spacing={2}>
              <Typography variant="h5">{Strings.profile.generalInformation}</Typography>
              <Divider />
              <GeneralInformationForm row={data} />
              <BankInformationPage row={data} />
              <EduInformationPage row={data} />
              <DocumentInformationPage row={data} />
            </Stack>
          </Stack>
        </Scrollbar>
      </>
    </LoadingGate>
  );
};
export { MyProfilePage };
